class NewsLetterPopup extends HTMLElement {
constructor() {
  super();
  console.log('NewsletterPopup class initialized.');

  if (window.location.pathname === '/challenge') {
    return;
  }

  this.cookieName = 'paris:newsletter-popup';
  this.popup = this.querySelector('.newsletter-popup');
  this.classes = {
    bodyClass: 'modal-popup-open',
    activeClass: 'active',
    closingClass: 'closing',
  };

  // Add event listeners for close buttons
  this.querySelectorAll('[data-popup-close]').forEach((button) => {
    button.addEventListener('click', this.onButtonClick.bind(this));
  });

  // Check if the popup should initialize
  if (!this.getCookie(this.cookieName)) {
    console.log('Calling init() from constructor...');
    this.init();
  }
}



init() {
  if (!this.popup) {
    console.log('Popup element not found. Exiting init().');
    return;
  }

  console.log('Popup element found. Starting 5-second delay.');
  setTimeout(() => {
    console.log('5 seconds passed. Opening popup now...');
    this.open();
  }, 5000); // Delay for 5 seconds
}


  
onButtonClick(event) {
  event.preventDefault();
  console.log('Close button clicked.');
  this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
}

open() {
  console.log('Popup opened by:', new Error().stack);
  document.body.classList.remove(this.classes.bodyClass);
  if (this.dataset.newsletterpopup == 'true') {
    document.body.classList.add(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
  }
}



close() {
  console.log('Popup is being closed.');
  this.popup.classList.add(this.classes.closingClass);
  setTimeout(() => {
    console.log('Popup closing animations finished.');
    this.popup.classList.remove(this.classes.activeClass);
    this.popup.classList.remove(this.classes.closingClass);
  }, 500);

  this.setCookie(this.cookieName, this.dataset.expiry || 7);
}

getCookie(name) {
  const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  console.log(`Checking for cookie "${name}":`, match ? match[2] : 'not found');
  return match ? match[2] : null;
}



  
  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('newsletter-popup', NewsLetterPopup);
